export default "__VITE_ASSET__yxAAtAtK__"